'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AbstractReactComponent = require('../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardItems = function (_AbstractReactCompone) {
    (0, _inherits3.default)(CardItems, _AbstractReactCompone);

    function CardItems() {
        (0, _classCallCheck3.default)(this, CardItems);
        return (0, _possibleConstructorReturn3.default)(this, (CardItems.__proto__ || (0, _getPrototypeOf2.default)(CardItems)).apply(this, arguments));
    }

    (0, _createClass3.default)(CardItems, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                bordered = _props.bordered;


            var cls = (0, _classnames2.default)("items-list", className, {
                bordered: bordered
            });

            return _react2.default.createElement(
                'div',
                { className: cls },
                this.props.children
            );
        }
    }]);
    return CardItems;
}(_AbstractReactComponent2.default); /**
                                      * Třída slouží pro obalení seznamu položek v Card komponentě, položkou seznamu je typicky CardBlock.
                                      *
                                      * Použití:
                                      * <Card>
                                      *   <CardHeader>Hlavicka</CardHeader>
                                      *   <CardBlock>nejaky obsah...</CardBlock>
                                      *   <CardItems>
                                      *       <CardBlock>polozka seznamu 1</CardBlock>
                                      *       <CardBlock>polozka seznamu 2</CardBlock>
                                      *       <CardBlock>polozka seznamu 3</CardBlock>
                                      *   </CardItems>
                                      * </Card>
                                      */


CardItems.propTypes = {
    bordered: _react2.default.PropTypes.bool // pokud je true, jsou položky zobrazeny s okrajem, standardně je false
};
CardItems.defaultProps = {
    bordered: false
};
exports.default = CardItems;
;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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